import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import copy from './copy';
import styles from './ContactHelpArticles.scss';
import getBuyerSupportLink from 'dibs-support-link/exports/getBuyerSupportLink';

type HelpArticleLinkProps = {
    linkText: ReactNode;
    description: ReactNode;
    url: string;
};

const HelpArticleLink: FC<HelpArticleLinkProps> = ({ linkText, description, url }) => {
    return (
        <div className={styles.helpArticle}>
            <Link className={styles.helpArticleLink} href={url} target="_blank">
                {linkText}
            </Link>
            <div className={styles.helpArticleMessage}>{description}</div>
        </div>
    );
};

const ContactHelpArticles: FC = () => {
    const viewAllMessage = (
        <FormattedMessage id="ContactHelpArticles.viewAll" defaultMessage="View All" />
    );
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <FormattedMessage
                    id="ContactHelpArticles.popularHelpArticles"
                    defaultMessage="Popular Help Articles"
                />
            </div>
            <div className={styles.section}>
                <div className={styles.sectionTop}>
                    <div className={styles.sectionTitle}>
                        <FormattedMessage
                            id="ContactHelpArticles.buyingOn1stDibs"
                            defaultMessage="Buying on 1stDibs"
                        />
                    </div>
                    <Link
                        className={styles.viewAllLink}
                        href={getBuyerSupportLink(
                            '/en-us/categories/14331958044187-Buying-on-1stDibs'
                        )}
                        target="_blank"
                    >
                        {viewAllMessage}
                    </Link>
                </div>
                <div className={styles.sectionBottom}>
                    <HelpArticleLink
                        linkText={copy.negotiatingPrices}
                        description={copy.negotiatingPricesDescription}
                        url={getBuyerSupportLink('/en-us/articles/14506784591259/')}
                    />
                    <HelpArticleLink
                        linkText={copy.onlinePayment}
                        description={copy.onlinePaymentDescription}
                        url={getBuyerSupportLink('/en-us/articles/14491056924443/')}
                    />
                    <HelpArticleLink
                        linkText={copy.shippingOverview}
                        description={copy.shippingOverviewDescription}
                        url={getBuyerSupportLink('/en-us/articles/14516879314587/')}
                    />
                </div>
            </div>
            <div className={styles.section}>
                <div className={styles.sectionTop}>
                    <div className={styles.sectionTitle}>
                        <FormattedMessage
                            id="ContactHelpArticles.sellingOn1stDibs"
                            defaultMessage="Selling on 1stDibs"
                        />
                    </div>
                    <Link
                        className={styles.viewAllLink}
                        href={getBuyerSupportLink(
                            '/en-us/categories/14480919967643-Selling-on-1stDibs'
                        )}
                        target="_blank"
                    >
                        {viewAllMessage}
                    </Link>
                </div>
                <div className={styles.sectionBottom}>
                    <HelpArticleLink
                        linkText={copy.applyingToSell}
                        description={copy.applyingToSellDescription}
                        url={getBuyerSupportLink('/en-us/articles/14490330236955/')}
                    />
                    <HelpArticleLink
                        linkText={copy.gettingItemAppraised}
                        description={copy.gettingItemAppraisedDescription}
                        url={getBuyerSupportLink('/en-us/articles/14490408074267/')}
                    />
                    <HelpArticleLink
                        linkText={copy.sellingPersonalItem}
                        description={copy.sellingPersonalItemDescription}
                        url={getBuyerSupportLink('/en-us/articles/14490370639515/')}
                    />
                </div>
            </div>
        </div>
    );
};

export default ContactHelpArticles;
